module.exports = __webpack_public_path__ + "img/curret_left_black.d15449f4.svg";